// extracted by mini-css-extract-plugin
module.exports = {"container":"PinsCategories_container__uhovl","list":"PinsCategories_list__2ZbRQ","box":"PinsCategories_box__lSI3-","active":"PinsCategories_active__11_tG"};